import type { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout as clearSession } from "@/api/auth";
import { useAuthStore } from "@/state/auth.store";
import { useBrandingStore } from "@/state/branding.store";
import { useLang } from "@/i18n/LanguageContext";
import { LangToggle } from "@/app/LangToggle";
import { TenantNav } from "@/app/TenantNav";
import { Footer } from "@/app/Footer";
import { Toaster } from "@/components";

export function AppShell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const brandName = useBrandingStore((s) => s.brandName);
  const { t } = useLang();

  function onLogout() {
    clearSession();
    logout();
    navigate("/login", { replace: true });
  }

  return (
    <>
      <header className="app-topbar">
        <Link to="/" className="app-brand">
          <span className="mark" aria-hidden="true" />
          <span>OnboardForge</span>
          {brandName && <span className="brand-chip">{brandName}</span>}
        </Link>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <LangToggle />
          {user ? (
            <>
              <Link to="/app" style={{ fontWeight: 600, fontSize: 15 }}>{t("Dashboard", "Dashboard")}</Link>
              <Link to="/app/account" style={{ color: "var(--grey-text)", fontFamily: "var(--mono)", fontSize: 13 }}>{user.email}</Link>
              <button className="btn btn-outline" style={{ padding: "8px 16px", fontSize: 14 }} onClick={onLogout}>
                {t("Uitloggen", "Log out")}
              </button>
            </>
          ) : (
            <Link to="/login" className="btn btn-primary" style={{ padding: "8px 18px", fontSize: 14 }}>
              {t("Inloggen", "Log in")}
            </Link>
          )}
        </div>
      </header>
      {user && <TenantNav />}
      <main className="app-main">{children}</main>
      <Footer />
      <Toaster />
    </>
  );
}
